module.exports = __webpack_public_path__ + "media/src/images/bg_yellow-6f63a6cb521fddf93482d1159e42e134.png";